import { Component, OnInit } from '@angular/core';
// Ancien import du tuto qui ne marche plus
// import * as firebase from 'firebase';
// !! Du coup ne pas oublier d'impoter les autres modules comme auth et firestore!!
import firebase from 'firebase/app';
import 'firebase/auth';
// import "firebase/firestore";
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // Erreur si je met pas une valeur pas défaut, Initializer comme la correction dit
  isAuth: boolean = false;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    firebase.auth().onAuthStateChanged(
      // Si l'utilisateur est authentifié, user existera
      (user) => {
        if (user) {
          this.isAuth = true;
        } else {
          this.isAuth = false;
        }
      }
    )
  }

  onSignOut() {
    this.authService.signOutUser();
  }

}
